import React from 'react';
import { useParams } from 'react-router-dom';
import CliOperationView, { UsageDetailPage, UsageEntriesQuery } from '../components/converter/CliOperationView';
import { apiService } from '../services/api';
import { CliOperation } from '../types';

async function loadOperation(id: string, query: UsageEntriesQuery): Promise<UsageDetailPage<CliOperation>> {
    const res = await apiService.cliGetUsage({ operation_id: id, ...query });
    return { subject: res.data.operation, entries: res.data.usage || [], total: res.data.total || 0 };
}

function CliOperationDetail() {
    const { id } = useParams<{ id: string }>();

    return (
        <CliOperationView
            id={id}
            backTo="/usage"
            pageSizeKey="cli-operation-files"
            load={loadOperation}
        />
    );
}

export default CliOperationDetail;
